import React, { FC } from "react"
import { useTranslation } from "react-i18next"
import "./AssistantLibrary.scss"
import bombeirosIcon from "Static/images/bombeirosicon.jpeg"
import planoDiretorGoianiaIcon from "Static/images/plano-diretor-goiania.jpg"
import abnt from "Static/images/abnt.jpg"

interface AssistantLibraryProps {
  onSelectAssistant?: (assistant: string) => void;
}

export const AssistantLibrary: FC<AssistantLibraryProps> = ({ onSelectAssistant }) => {
  const { t } = useTranslation('activities');

  return (
    <div className="assistant-library-view">
      <div className="library-header">
        <h1>{t('aiChat.library.title')}</h1>
        <p>{t('aiChat.library.subtitle')}</p>
      </div>

      <div className="library-content">

        <div className="library-search">
          <div className="search-input-wrapper">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path d="M21 21l-4.35-4.35" stroke="#8697A8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <circle cx="11" cy="11" r="6" stroke="#8697A8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <input
              type="text"
              placeholder={t('aiChat.searchAssistant')}
              className="library-search-input"
            />
          </div>
        </div>

        <div className="library-categories">
          <button className="category-tab active">{t('aiChat.library.tabAll')}</button>
          <button className="category-tab">{t('aiChat.library.tabAbnt')}</button>
          <button className="category-tab">{t('aiChat.library.tabBim')}</button>
          <button className="category-tab">{t('aiChat.library.tabBudget')}</button>
        </div>

        <div className="assistants-grid">
          <div className="assistant-card" style={{ cursor: 'pointer' }} onClick={() => onSelectAssistant?.('Bombeiros')}>
            <div className="assistant-icon bombeiros-bg">
              <img src={bombeirosIcon} alt="CBM-GO" />
            </div>
            <div className="assistant-info">
              <h3>{t('aiChat.library.assistants.cbmgoTitle')}</h3>
              <p>{t('aiChat.library.assistants.cbmgoDesc')}</p>
            </div>
            <span className="by-coordly">{t('aiChat.library.byCoordly')}</span>
          </div>

          <div className="assistant-card">
            <div className="assistant-icon">
              <img src={abnt} alt="ABNT NBR 15575" />
            </div>
            <div className="assistant-info">
              <h3>{t('aiChat.library.assistants.abntNbrTitle')}</h3>
              <p>{t('aiChat.library.assistants.abntNbrDesc')}</p>
            </div>
            <span className="by-coordly">{t('aiChat.library.byCoordly')}</span>
          </div>

          <div className="assistant-card">
            <div className="assistant-icon">
              <img src={planoDiretorGoianiaIcon} alt="Goiânia" />
            </div>
            <div className="assistant-info">
              <h3>{t('aiChat.library.assistants.goianiaTitle')}</h3>
              <p>{t('aiChat.library.assistants.goianiaDesc')}</p>
            </div>
            <span className="by-coordly">{t('aiChat.library.byCoordly')}</span>
          </div>

          <div className="assistant-card">
            <div className="assistant-icon">
              <img src={abnt} alt="ABNT" />
            </div>
            <div className="assistant-info">
              <h3>{t('aiChat.library.assistants.abntTitle')}</h3>
              <p>{t('aiChat.library.assistants.abntDesc')}</p>
            </div>
            <span className="by-coordly">{t('aiChat.library.byCoordly')}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssistantLibrary
